import { BubbleMenu as BaseBubbleMenu, useEditorState } from "@tiptap/react";
import deepEql from "fast-deep-equal";
import { useCallback } from "react";
import { sticky } from "tippy.js";
import { Icon } from "../../../../../utils/ui/Icon";
import { Toolbar } from "../../../../../utils/ui/Toolbar";
import { MenuProps } from "../../../components/menus/types";
import { getRenderContainer } from "../../../utils/getRenderContainer";
import { ColumnLayout } from "../Columns";

const COLUMNS_MENU_PLUGIN_KEY = "columnsMenu";

export const ColumnsMenu = ({ editor, appendTo }: MenuProps) => {
  const getReferenceClientRect = useCallback(() => {
    const renderContainer = getRenderContainer(editor, "columns");
    const rect = renderContainer?.getBoundingClientRect() || new DOMRect(-1000, -1000, 0, 0);

    return rect;
  }, [editor]);

  const shouldShow = useCallback(() => {
    const isColumns = editor.isActive("columns");
    return isColumns;
  }, [editor]);

  const onColumnLeft = useCallback(() => {
    editor.chain().focus().setLayout(ColumnLayout.SidebarLeft).run();
  }, [editor]);

  const onColumnRight = useCallback(() => {
    editor.chain().focus().setLayout(ColumnLayout.SidebarRight).run();
  }, [editor]);

  const onColumnTwo = useCallback(() => {
    editor.chain().focus().setLayout(ColumnLayout.TwoColumn).run();
  }, [editor]);
  const { isColumnLeft, isColumnRight, isColumnTwo } = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isColumnLeft: ctx.editor.isActive("columns", { layout: ColumnLayout.SidebarLeft }),
        isColumnRight: ctx.editor.isActive("columns", { layout: ColumnLayout.SidebarRight }),
        isColumnTwo: ctx.editor.isActive("columns", { layout: ColumnLayout.TwoColumn }),
      };
    },
    equalityFn: deepEql,
  });

  return (
    <BaseBubbleMenu
      editor={editor}
      pluginKey={COLUMNS_MENU_PLUGIN_KEY}
      shouldShow={shouldShow}
      updateDelay={0}
      tippyOptions={{
        offset: [0, 8],
        zIndex: 1000,
        popperOptions: {
          modifiers: [{ name: "flip", enabled: false }],
        },
        getReferenceClientRect,
        appendTo: () => appendTo?.current,
        plugins: [sticky],
        sticky: "popper",
      }}
    >
      <Toolbar.Wrapper title="Columns">
        <Toolbar.Button tooltip="Left narrow" active={isColumnLeft} onClick={onColumnLeft}>
          <Icon name="PanelLeft" />
        </Toolbar.Button>
        <Toolbar.Button tooltip="Equal columns" active={isColumnTwo} onClick={onColumnTwo}>
          <Icon name="Columns2" />
        </Toolbar.Button>
        <Toolbar.Button tooltip="Right narrow" active={isColumnRight} onClick={onColumnRight}>
          <Icon name="PanelRight" />
        </Toolbar.Button>
      </Toolbar.Wrapper>
    </BaseBubbleMenu>
  );
};

export default ColumnsMenu;
